import React from 'react';
import Support from './Support';

export default function PageError() {
  return (
    <div id="content" className="text-center my-5">
      <p className="text-primary-blue font-avenir-black text-3xl">Uh Oh!</p>
      <p className="text-lg font-avenir-medium my-2">An Error Occurred</p>
      <p>Please contact Credit Key support for further assistance.</p>

      <Support fullText={false} />
    </div>
  );
}
